import React from "react";
import { connect } from "react-redux";
import { setCartTotals, setCartItems, toggleVisibility } from "../../Redux/slices/cart";
import CartItem from "./CartItem";
import DarkOverlay from "../DarkOverlay";
import { client } from "../../../App";
import { GET_CART } from "../../apollo";

const mapStateToProps = state => {
    return {
        total: state.cart.totals.total,
        subTotal: state.cart.totals.subTotal,
        tax: state.cart.totals.tax,
        itemCount: state.cart.itemCount,
        items: state.cart.items,
        visible: state.cart.visible,
        loading: state.cart.loading
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setCartTotals: payload => dispatch(setCartTotals(payload)),
        setCartItems: payload => dispatch(setCartItems(payload)),
        toggleVisibility: payload => dispatch(toggleVisibility(payload))
    };
};

class Cart extends React.Component {
    componentDidMount() {
        client.query({
            query: GET_CART
        }).then(resp => {
            this.props.setCartTotals({
                total: resp.data.cart.total,
                subTotal: resp.data.cart.subtotal,
                tax: resp.data.cart.totalTax
            });

            this.props.setCartItems({
                itemCount: resp.data.cart.contents.itemCount,
                items: resp.data.cart.contents.nodes.filter((item) => {
                    return item.product !== null;
                }).map(item => {
                    return {
                        id: item.variation.node.databaseId,
                        cartKey: item.key,
                        quantity: item.quantity,
                        mainImageSrc: item.product.node.image.mediaItemUrl,
                        name: item.product.node.name,
                        price: item.variation.node.price,
                        size: item.variation.node.attributes.nodes[0].value
                    };
                })
            });
        });
    }

    render() {
        var cartItems = this.props.items.map((item, key) => {
            return <CartItem key={key}
                        id={item.id}
                        cartKey={item.cartKey}
                        quantity={item.quantity}
                        name={item.name}
                        imageSrc={item.mainImageSrc}
                        price={item.price}
                        size={item.size} />
        });

        if (cartItems.length === 0) {
            cartItems = <span className="empty-cart">Your cart is empty</span>;
        }

        return <DarkOverlay top={0} visible={this.props.visible} closeSelf={() => this.props.toggleVisibility(false)}>
            <div className="cart-wrap transform-fade-x">
                <div className="cart-header" onClick={() => this.props.toggleVisibility(false)}>
                    <span className="title">Cart {this.props.itemCount === 0 ? "" : "(" + this.props.itemCount + ")"}</span>
                    <div className="close-icon"></div>
                </div>

                <div className={"cart-items-wrap" + (this.props.loading ? " loading" : "")}>
                    {cartItems}
                </div>

                <div className="continue-checkout-wrap">
                    <div className="totals-wrap">
                        <span className="label">Total</span>
                        <span className="value" dangerouslySetInnerHTML={{__html: this.props.total}}></span>
                    </div>

                    <a className="checkout-btn" href="/checkout">Go to checkout</a>
                </div>
            </div>
        </DarkOverlay>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cart);